module.exports = __webpack_public_path__ + "img/airport-shuttle_white.a6bda11b.svg";